/**
 * Anniversary Trigger Component
 *
 * Trigger: "membership anniversary"
 * No additional fields needed.
 */

import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { TriggerComponentProps } from '../automationTriggers';

export const AnniversaryTrigger: FC<TriggerComponentProps> = ({
  readOnly,
}) => {
  const { t } = useTranslation();

  if (readOnly) {
    return <span>{t('automations.triggers.membershipAnniversary')}</span>;
  }

  // Edit mode - no fields needed
  return null;
};
